module.exports = __webpack_public_path__ + "img/air_state_1.4bb65b8a.png";